import { render } from "./StudioDrawer.vue?vue&type=template&id=91ae2516&scoped=true&ts=true"
import script from "./StudioDrawer.vue?vue&type=script&lang=ts"
export * from "./StudioDrawer.vue?vue&type=script&lang=ts"

import "./StudioDrawer.vue?vue&type=style&index=0&id=91ae2516&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ae2516"]])

export default __exports__